import React, { useState } from 'react';
import { ControlButton } from './ControlButton/index.ts';
import { T } from '@colonist/ui';
import { ReplaySlider } from './ReplaySlider/index.ts';
import { AvatarList } from './AvatarList/index.ts';
import styles from './ReplayControlsContent.module.scss';
import clsx from 'clsx';
import IconArrowUp from '@static/images/icon_arrow_up.svg';
import IconArrowDown from '@static/images/icon_arrow_down.svg';
import { ReplayControlsShareButton } from './ShareButton/ReplayControlsShareButton.tsx';
import Icon05x from '@static/images/icon_05x.svg';
import Icon1x from '@static/images/icon_1x.svg';
import Icon2x from '@static/images/icon_2x.svg';
import Icon4x from '@static/images/icon_4x.svg';
import Icon8x from '@static/images/icon_8x.svg';
import IconRewindStart from '@static/images/icon_rewind_start.svg';
import IconRewind from '@static/images/icon_rewind.svg';
import IconPause from '@static/images/icon_pause.svg';
import IconPlay from '@static/images/icon_play.svg';
import IconFastForward from '@static/images/icon_forward.svg';
import IconFastForwardToEnd from '@static/images/icon_forward_end.svg';
const ORDERED_PLAYBACK_SPEEDS = [
    '1x',
    '2x',
    '4x',
    '8x',
    '05x'
];
const PLAYBACK_SPEED_ICON = {
    '05x': Icon05x,
    '1x': Icon1x,
    '2x': Icon2x,
    '4x': Icon4x,
    '8x': Icon8x
};
export const ReplayControlsContent = ({ playbackSpeed, onChangePlaybackSpeed, isPlaying, onTogglePlayback, onPreviousAction, onNextAction, onPreviousTurn, onNextTurn, onShare, currentPlayerPerspective, playerUserStates, onChangePerspective, numberOfActions, currentActionIndex, onSliderChangeActionIndex, highlightData, className, disableTooltips })=>{
    const [isExpanded, setIsExpanded] = useState(true);
    const handleSpeedChange = ()=>{
        const currentIndex = ORDERED_PLAYBACK_SPEEDS.indexOf(playbackSpeed);
        const nextIndex = (currentIndex + 1) % ORDERED_PLAYBACK_SPEEDS.length;
        onChangePlaybackSpeed(ORDERED_PLAYBACK_SPEEDS[nextIndex]);
    };
    const toggleExpand = ()=>setIsExpanded(!isExpanded);
    const hasHighlightData = highlightData.length > 0;
    const isFirstAction = currentActionIndex <= -1;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.replayControlsContainer, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.controllerButtons
    }, /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconRewindStart,
        alt: "strings:imgAlts.RewindToStart",
        disabled: isFirstAction,
        onClick: onPreviousTurn,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.previousTurn"
        }),
        disableTooltip: disableTooltips
    }), /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconRewind,
        alt: "strings:imgAlts.Rewind",
        disabled: isFirstAction,
        onClick: onPreviousAction,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.previousAction"
        }),
        disableTooltip: disableTooltips
    }), isPlaying ? /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconPause,
        alt: "strings:imgAlts.Pause",
        onClick: onTogglePlayback,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.playPause"
        }),
        disableTooltip: disableTooltips
    }) : /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconPlay,
        alt: "strings:imgAlts.Play",
        onClick: onTogglePlayback,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.playPause"
        }),
        disableTooltip: disableTooltips
    }), /*#__PURE__*/ React.createElement(ControlButton, {
        icon: PLAYBACK_SPEED_ICON[playbackSpeed],
        alt: "strings:imgAlts.Play",
        onClick: handleSpeedChange,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.velocity"
        }),
        disableTooltip: disableTooltips
    }), /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconFastForward,
        alt: "strings:imgAlts.FastForward",
        onClick: onNextAction,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.nextAction"
        }),
        disableTooltip: disableTooltips
    }), /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconFastForwardToEnd,
        alt: "strings:imgAlts.FastForwardToEnd",
        onClick: onNextTurn,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.nextTurn"
        }),
        disableTooltip: disableTooltips
    }), /*#__PURE__*/ React.createElement("img", {
        className: styles.expandIcon,
        onClick: toggleExpand,
        src: isExpanded ? IconArrowUp : IconArrowDown
    })), /*#__PURE__*/ React.createElement(ReplaySlider, {
        highlightData: highlightData,
        max: numberOfActions,
        onChange: onSliderChangeActionIndex,
        shouldShowHighlights: hasHighlightData && isExpanded,
        value: currentActionIndex
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.bottomMenu, {
            [styles.bottomMenuVisible]: isExpanded
        })
    }, /*#__PURE__*/ React.createElement(AvatarList, {
        currentPlayerPerspective: currentPlayerPerspective,
        onChangePerspective: onChangePerspective,
        playerUserStates: playerUserStates
    }), /*#__PURE__*/ React.createElement(ReplayControlsShareButton, {
        onShare: onShare
    })));
};
